import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, PageHeader, EmptyState } from '@/components/ui'
import { Mail } from 'lucide-react'

export const Route = createFileRoute('/store/$id/marketing')({
  component: StoreMarketingPage,
})

function StoreMarketingPage() {
  return (
    <>
      <PageHeader title="Marketing" description="Newsletter, campañas y automaciones" />
      <div className="p-8">
        <Card>
          <CardContent className="p-0">
            <EmptyState
              title="Sin campañas activas"
              description="Schema newsletter_subscribers existe. Falta CRUD para enviar campañas a la lista, editor de templates HTML/React Email, automaciones (welcome flow, abandoned cart)."
            />
            <div className="border-t border-neutral-800 p-4 text-xs text-neutral-500 flex items-center gap-2">
              <Mail className="size-4" />
              <span>Endpoint pendiente: <code className="text-neutral-300">GET /api/v1/marketing/subscribers</code></span>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
